import "./SingleInfoworldArticleTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleInfoworldArticleTemplateSection from "./sections/SingleInfoworldArticleTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleInfoworldArticleTemplatePage() {

  return (
    <div>
      <Header />
      <SingleInfoworldArticleTemplateSection />
      <Footer />
    </div>
  )
}
